<overlay-header [showCloseButton]="true" (closeClick)="closeClick()" *ngIf="showAsDialog">
    My Reports
</overlay-header>

<page-header pageTitle="My Reports" class="flex-header" *ngIf="!showAsDialog"></page-header>
<div class="flex-content">
    <mat-tab-group [(selectedIndex)]="selectionIndex">
        <mat-tab #tabs *ngFor="let tab of tabNames; let index = index">
            <ng-template mat-tab-label>
                <span>{{tab | translate}}</span>
            </ng-template>
        </mat-tab>
    </mat-tab-group>


    <div *ngIf="selectionIndex > -1">
        <my-reports-tab *ngIf="selectionIndex == tabIndex.MyReports" [myReportsFolders]="myReportsFolders"
            (myReportFolderSaveEvent)="getTabsData(false)">
        </my-reports-tab>

        <assigned-reports-tab *ngIf="selectionIndex == tabIndex.AssignedReports"
            [assignedReportFolders]="assignedReportFolders">
        </assigned-reports-tab>
    </div>
</div>

<div class="flex-footer">
    <div class="flex-footer-left">
        <tyl-button image="add.png" *ngIf="selectionIndex > -1 && selectionIndex == tabIndex.MyReports"
            label="Add Folders" (clickEvent)="addFolderClick()"></tyl-button>

        <tyl-button *ngIf="selectionIndex > -1 && selectionIndex == tabIndex.MyReports"
            image="queue.png" label="Queue" translate (clickEvent)="openQueueList()"></tyl-button>
    </div>


    <div class="flex-footer-middle" style="align-items: center">

    </div>
    <div class="flex-footer-right" style="display: flex;align-items: center;padding-right: 20px;">
        <tyl-button image="next arrow.png" label="All Reports" (clickEvent)="allReportsClick()"></tyl-button>
    </div>

</div>